import { createAsyncThunk } from "@reduxjs/toolkit";
import { API, axiosInstance } from "lib";

export const getEnvironment = createAsyncThunk(
  "settings/getEnvironment",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(API.GET_ENVIRONMENT, data);
      return response.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data || "Failed to fetch environment data"
      );
    }
  }
);

export const updateEnvironment = createAsyncThunk(
  "settings/updateEnvironment",
  async (environmentParams, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        API.UPDATE_ENVIRONMENT,
        environmentParams
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data || "Failed to update environment"
      );
    }
  }
);
